import { render, staticRenderFns } from "./IntegrationParameter.vue?vue&type=template&id=5b477e37&scoped=true"
import script from "./IntegrationParameter.vue?vue&type=script&lang=js"
export * from "./IntegrationParameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b477e37",
  null
  
)

export default component.exports